import styled, { css } from 'styled-components/macro';
import { colors } from '@united-talent-agency/components';
import EllipsisText from '../EllipsisText';

export const TableCell = styled.td`
  min-width: 150px;
  text-overflow: ellipsis;
  font-weight: 300;
  cursor: pointer;
  border-right: 1px solid ${colors.whiteSmoke};
  overflow: visible;
`;

export const ContactDisplayContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: -1px;
  height: 32px;
  border: 0.5px solid transparent;
  box-shadow: 0px 0px 0.5px 1px transparent;
  gap: 6px;

  ${({ editContact }) =>
    editContact
      ? css`
          padding-left: 4px;
          width: 95%;
          border-collapse: unset;
          border-color: ${colors.linkBlue};
          box-shadow: 0px 0px 0.5px 1px ${colors.linkBlue};
        `
      : css`
          padding-left: 5px;
          padding-right: 5px;
        `}
`;

export const ContactInputContainer = styled.div`
  position: absolute;
  z-index: 3;
  background: white;
  transform: translateY(-50%);
`;

export const ContactContentWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 2px;
  min-width: 0; /* Allow flex item to shrink below content size */
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};

  ${({ isClickable }) =>
    isClickable &&
    css`
      &:hover {
        text-decoration: underline;
        text-decoration-color: ${colors.linkBlue};
      }
    `}
`;

export const ContactTypeWrapper = styled.span`
  margin: 3px 2px 0 0;
`;

export const ContactTextSpan = styled(EllipsisText)`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  color: ${({ isClickable }) => (isClickable ? colors.linkBlue : 'inherit')};
`;

export const EditIconButton = styled.button`
  background-color: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  padding: 6px;
  font-size: 14px;
  color: ${colors.gray500};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  min-width: 24px;
  min-height: 24px;

  &:hover {
    background-color: ${colors.fadedLinkBlue};
  }

  &:active {
    background-color: ${colors.gray100};
    transform: scale(0.95);
  }

  &:focus {
    outline: 2px solid ${colors.linkBlue};
    outline-offset: 1px;
  }
`;
